import { Analysis as _Analysis } from '@team-milva/lab-models/resources'

export class Analysis extends _Analysis {}
